<ng-container [ngSwitch]="step?.target_type">
    <ng-template ngSwitchCase="file">
        <app-component-file-navigator
          (eventSelected)="onItemSelected($event[0])"
          (eventSubmit)="onSubmitSelected()"
          [isForContract]="true"
          [maxHeight]="'1500px'"
          [selects]="this.currentTargetData ? currentTargetData : null">
        </app-component-file-navigator>
    </ng-template>
    <ng-template ngSwitchCase="task">
      <app-tasks-table-mt 
        [selectTargetMode]="true"
        (eventSubmitSelectedTask)="onSubmitSelected($event)"
      >
      </app-tasks-table-mt>
    </ng-template>
    <ng-template ngSwitchCase="sub_contract">
      <app-contract-table-mt
        [selectTargetMode]="true"
        [selectTargetModeGuid]="contractGuid"
        (eventSubmitSelectedTask)="onSubmitSelected($event)"
      >
      </app-contract-table-mt>
    </ng-template>
</ng-container>